import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../interceptor/axiosInstance";

const initialState = {
  login: { loading: false, success: null, error: null },
  pendingInvoices: {
    data: null,
    loading: false,
  },
};

export const login = createAsyncThunk(
  "pendingInvoices/login",
  async (action) => {
    const config = {
      url: `auth/login`,
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: {
        // mobile: action?.phoneNumber,
        email: action?.civilNo,
        password: action?.password,
        country_code: "+965",
      },
    };
    return await axiosInstance(config)
      .then((response) => response)
      .catch((errors) => errors.response.data);
  }
);

export const fetchPendingInvoices = createAsyncThunk(
  "pendingInvoices/fetchPendingInvoices",
  async (action) => {
    const config = {
      url: `backend/invoices/installment`,
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      params: {
        paymentStatus: action?.paid ? action?.paid : null,
      },
    };
    return await axiosInstance(config)
      .then((response) => response)
      .catch((errors) => errors.response.data);
  }
);

const pendingInvoicesReducer = createSlice({
  name: "pendingInvoices",
  initialState,
  reducers: {
    onAuthenticate: (state, action) => {
      state.pendingInvoices.loading = action?.payload?.loading;
      state.pendingInvoices.isAuthenticated = action?.payload?.isAuthenticated;
    },
    onGetData: (state, action) => {
      state.pendingInvoices.data = action?.payload?.data;
    },
  },
  extraReducers: (builder) => {
    /***** Login *****/
    builder.addCase(login.pending, (state, action) => {
      state.login.loading = true;
    });
    builder.addCase(login.fulfilled, (state, action) => {
      console.log(action);
      state.login.loading = false;
      const payload = action?.payload;
      if (payload?.status === 200 || payload?.status === 201) {
        const token = payload?.data?.data?.accessToken;
        if (token) {
          localStorage.setItem("token", token);
          window.location.href = "/invoices";
        }
        state.login.success = true;
        state.login.error = false;
      }
    });
    builder.addCase(login.rejected, (state, action) => {
      console.log(action);
      state.login.loading = false;
      state.login.success = false;
      state.login.error = true;
    });
    /***** Login *****/

    /***** Pending Invoices *****/
    builder.addCase(fetchPendingInvoices.pending, (state, action) => {
      state.pendingInvoices.loading = true;
    });
    builder.addCase(fetchPendingInvoices.fulfilled, (state, action) => {
      state.pendingInvoices.loading = false;
      const payload = action?.payload;
      console.log(payload);
      if (payload?.status === 200 || payload?.status === 201) {
        const data = payload?.data?.data;
        state.pendingInvoices.data = data;
      }
    });
    builder.addCase(fetchPendingInvoices.rejected, (state, action) => {
      state.pendingInvoices.loading = false;
    });
    /***** Pending Invoices *****/
  },
});

export const { onAuthenticate, onGetData } = pendingInvoicesReducer.actions;

export default pendingInvoicesReducer.reducer;
